
import { Injectable, InjectionToken, DOCUMENT, inject } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { OverlayContainer } from '@angular/cdk/overlay';


export interface CustomOverlayConfig {
  overlayContainerClass?: string,
}

export const CUSTOM_OVERLAY_CONFIG = new InjectionToken<CustomOverlayConfig>('custom-overlay-config');

@Injectable()
export class CustomOverlayContainer extends OverlayContainer {
  protected _platform: Platform;
  private config = inject<CustomOverlayConfig>(CUSTOM_OVERLAY_CONFIG);


  constructor() {
    const document = inject(DOCUMENT);
    const _platform = inject(Platform);

    super(document, _platform);
  
    this._platform = _platform;
  }

  protected override _createContainer(): void {
    super._createContainer();
    this._containerElement.classList.add(this.config.overlayContainerClass);
  }
 }
